import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 400px;
`;

const Input = styled.input`
  padding: 14px 16px;
  font-size: 16px;
  border: 2px solid rgba(64, 87, 109, 0.1);
  border-radius: 8px;
  outline: none;
  font-family: inherit;

  &:focus {
    border-color: #6366f1;
  }
`;

const Button = styled.button`
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 600;
  font-family: inherit;
  background-color: #6366f1;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:hover:enabled {
    background-color: #4f46e5;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

function extractMagicId(input: string): string {
  const trimmed = input.trim();
  const match = trimmed.match(/\/presentation\/([^/?#]+)/);
  if (match) {
    return match[1];
  }
  return trimmed;
}

const JoinForm = () => {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const magicId = extractMagicId(value);
    if (magicId) {
      navigate(`/presentation/${magicId}`);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        type="text"
        placeholder="Enter session ID or paste link"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <Button type="submit" disabled={!value.trim()}>
        Join Presentation
      </Button>
    </Form>
  );
};

export default JoinForm;
